export default __webpack_public_path__ + "static/media/logo-dark.f2d74599.png";